import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface WithdrawWithdrawingProps {
  store: WithdrawStore
}

export const WithdrawWithdrawing = observer(({ store }: WithdrawWithdrawingProps) => {
  if (!store.lock) return null

  const Component = store.resetTxHash ? MultilineMessageBox : ShortMessageBox

  return (
    <Component variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">
        <BodySM className="text-t200">Withdrawing your tokens. Please wait for the transaction to complete...</BodySM>
      </BodySM>

      {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" className="mt-2" />}
    </Component>
  )
})
